import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Customer, CustomerGungMappedEntityAddress } from '../../models/customer';

/** A registered delivery location as the AI order parser's picker uses it. */
export type AiParserDeliveryLocation = Partial<CustomerGungMappedEntityAddress> & { deliveryLocationCode: string };

/**
 * The delivery locations a customer has registered, for pickers that offer them as a starting
 * point. Read-only by design: nothing here ever writes a corrected address back to customer
 * master data.
 *
 * The default reads the canonical CustomerGME, which the ERP integrations that populate it
 * deliver already in this shape. An ERP that keeps its addresses elsewhere subclasses this and
 * provides itself in that ERP's module; an empty list simply means no picker is offered.
 */
@Injectable({
  providedIn: 'root'
})
export class CustomerDeliveryLocationsService {
  getDeliveryLocations(customer: Customer): Observable<AiParserDeliveryLocation[]> {
    // AddressGME carries deliveryLocationCode, which the master CustomerGungMappedEntityAddress type omits.
    const addresses = (customer?.extra?.gme?.deliveryAddresses || []) as Partial<AiParserDeliveryLocation>[];
    return of(addresses.filter((address): address is AiParserDeliveryLocation => !!address?.deliveryLocationCode));
  }
}
